import React from 'react';

export const Tab = (props: any) => {
    if (props.isSelected) {
        return <div style={{ backgroundColor: 'white' }}>{props.children}</div>;
    }
    return null;
};
